import request from "@/utils/request";

export interface AddBusinessRequest {
	/**
	 * 企业地址
	 */
	address: string;
	/**
	 * 企业简称
	 */
	alias: string;
	/**
	 * 联系人
	 */
	contact: string;
	/**
	 * 行业分类id
	 */
	industry_id: number;
	/**
	 * 组织分类id
	 */
	institution_id: number;
	/**
	 * 企业简介
	 */
	introduce?: string;
	/**
	 * 企业标签
	 */
	label?: string[];
	/**
	 * 地址纬度
	 */
	latitude?: string;
	/**
	 * 企业logo
	 */
	logo: string;
	/**
	 * 地址经度
	 */
	longitude?: string;
	/**
	 * 手机号
	 */
	mobile: string;
	/**
	 * 企业名称
	 */
	name: string;
	/**
	 * 企业宣传语
	 */
	slogan?: string;
}

/**
 * 新增企业
 */
export const addBusiness = (data: AddBusinessRequest) =>
	request.post<{ company_id: number }>("/company/register", data);

export interface FetchBusinessListRequest {
	/**
	 * 名称/简介关键词查询
	 */
	keyword?: string;
	/**
	 * 拥有者类型：0-全部 1-创建者 2-管理者
	 */
	owner_type: number;
}

export interface BusinessListDatumIndustry {
	/**
	 * 行业二级ID
	 */
	industry_id: number;
	/**
	 * 行业名称
	 */
	name: string;
	/**
	 * 行业一级ID
	 */
	pid: number;
}

export interface BusinessListDatumInstitution {
	/**
	 * 机构二级ID
	 */
	institution_id: number;
	/**
	 * 机构名称
	 */
	name: string;
	/**
	 * 机构二级ID
	 */
	pid: number;
}

export interface BusinessListDatum {
	/**
	 * 地址
	 */
	address: string;
	/**
	 * 别名
	 */
	alias: string;
	/**
	 * 企业id
	 */
	company_id: number;
	/**
	 * 联系人
	 */
	contact: string;
	/**
	 * 背景图
	 */
	cover?: string;
	/**
	 * 行业详情
	 */
	industry?: BusinessListDatumIndustry;
	/**
	 * 行业二级ID
	 */
	industry_id?: number;
	/**
	 * 机构详情
	 */
	institution?: BusinessListDatumInstitution;
	/**
	 * 机构二级ID
	 */
	institution_id?: number;
	/**
	 * 企业介绍
	 */
	introduce?: string;
	/**
	 * 标签list
	 */
	label?: string[];
	/**
	 * 维度
	 */
	latitude?: string;
	/**
	 * 企业logo
	 */
	logo: string;
	/**
	 * 经度
	 */
	longitude?: string;
	/**
	 * 企业编码
	 */
	merchant_code?: string;
	/**
	 * 联系手机号
	 */
	mobile: string;
	/**
	 * 企业名称
	 */
	name: string;
	/**
	 * 宣传语
	 */
	slogan?: string;
}

export type FetchBusinessListResponse = Array<BusinessListDatum>;

/**
 * 获取企业列表
 * @param data 请求参数
 * @returns 企业列表
 */
export const fetchBusinessList = (data: FetchBusinessListRequest) =>
	request.post<FetchBusinessListResponse>("/company/list", data);

export interface EditBusinessRequest {
	/**
	 * 企业地址
	 */
	address?: string;
	/**
	 * 企业简称
	 */
	alias?: string;
	/**
	 * 企业id
	 */
	company_id: number;
	/**
	 * 联系人
	 */
	contact?: string;
	/**
	 * 组织id（二级id）
	 */
	industry_id?: number;
	/**
	 * 机构id（二级id）
	 */
	institution_id?: number;
	/**
	 * 企业简介
	 */
	introduce?: string;
	/**
	 * 标签（数组）
	 */
	label?: string[];
	/**
	 * 地址纬度
	 */
	latitude?: string;
	/**
	 * 企业logo
	 */
	logo?: string;
	/**
	 * 地址经度
	 */
	longitude?: string;
	/**
	 * 手机号
	 */
	mobile?: string;
	/**
	 * 企业名称
	 */
	name?: string;
	/**
	 * 宣传语
	 */
	slogan?: string;
}

/**
 * 编辑企业
 */
export const editBusiness = (data: EditBusinessRequest) => request.post("/company/edit", data);
